//#region FUNCTION transformString
/**
 * Transforms a camelCase string to a string with a space before uppercase letters and capitalizes the first letter.
 * Example: "stringValue" -> "String Value"
 *
 * @param str The input string in camelCase format.
 * @returns A string with spaces inserted before uppercase letters and the first letter capitalized.
 */
export function transformCamelCaseStringSeparated(str: string): string {
  return str
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/^([a-z])/, (match) => match.toUpperCase());
}

//#endregion

export function transformCamelCaseString(str: string): string {
  return str
    .replace(/^([a-z])/, (match) => match.toUpperCase());
}
